<template>
  <div
    @touchstart="touchStartHandler"
    @touchend="touchEndHandler"
  >
    <slot />
  </div>
</template>

<script>
// an: custom value to determine the distance of the swipe in pixels
const MINIMUM_PIXEL_SWIPE = 75;

export default {
  data() {
    return {
      touchStartX: null,
      touchEndX: null,
    };
  },
  methods: {
    touchStartHandler(event) {
      // TODO: Implement touchStartY when needed
      this.touchStartX = event.changedTouches[0].screenX;
    },
    touchEndHandler(event) {
      // TODO: Implement touchEndY when needed
      this.touchEndX = event.changedTouches[0].screenX;
      const pixelDiff = Math.abs(this.touchEndX - this.touchStartX);

      if (pixelDiff < MINIMUM_PIXEL_SWIPE) {
        return;
      }

      let swipeDirection = '';

      if (this.touchEndX < this.touchStartX) {
        swipeDirection = 'swipe-left';
      } else if (this.touchEndX > this.touchStartX) {
        swipeDirection = 'swipe-right';
      }

      this.$emit(swipeDirection, {
        touchStartX: this.touchStartX,
        touchEndX: this.touchEndX,
      });
    },
  },
};
</script>
